// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_c0w","col":"styles_col__1RT-4"};